export default __webpack_public_path__ + "eed1e00571e61924166a0ef145da30eb.svg";